import { connect } from 'react-redux';
import AsyncHeader from './AsyncHeader';
import { showLoginModal } from '../../redux/modules/login';

const mapDispatchToProps = {
  showLoginModal
};

const mapStateToProps = ({
  system: { siteName, isTouchDevice, isMobile },
  intl: { locale, currency },
  user: { isUserLogged },
  content: { header: data }
}) => ({
  siteName,
  locale,
  isTouchDevice,
  isMobile,
  isUserLogged,
  data,
  currency
});

export default connect(mapStateToProps, mapDispatchToProps)(AsyncHeader);



// WEBPACK FOOTER //
// ./src/universal/components/Header/index.js